"use client";
import React, { MouseEventHandler, useRef, useState } from "react";
import styles from "./carousel.module.scss";
import { Carousel as AntCarousel } from "antd";
import Image from "next/image";
import { CarouselRef } from "antd/es/carousel";
import classNames from "classnames";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import Link from "next/link";
import { MdArrowOutward } from "react-icons/md";
import GradientBackground from "@/components/layout/gradient-background";
import { useRouter } from "next/navigation";
import { CAROUSEL_SLIDES } from "@/constants/carousel-slides.constants";
import ArrowButtonRight from "@/components/layout/arrow-button/arrow-button-right";
import ArrowButtonLeft from "@/components/layout/arrow-button/arrow-button-left";

type Props = {};

const Carousel = (props: Props) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const carouselRef = useRef<CarouselRef>(null);

  const { push } = useRouter();

  const handleIterate = (direction: "prev" | "next") => {
    if (carouselRef.current) {
      if (direction === "prev") carouselRef.current.prev();
      if (direction === "next") carouselRef.current.next();
    }
  };

  const handleGoTo = (index: number) => {
    if (carouselRef.current) {
      carouselRef.current.goTo(index);
    }
  };

  return (
    <div className={styles.carouselWrapper}>
      <div className={styles.carouselContainer}>
        <div className={styles.wrapper}>
          <AntCarousel
            ref={carouselRef}
            className={styles.carousel}
            dots={false}
            autoplaySpeed={7000}
            draggable
            infinite
            beforeChange={(_, nextslide) => setActiveSlide(nextslide)}>
            {CAROUSEL_SLIDES.map((img, i) => (
              <div key={"slide" + i} className={styles.slide}>
                <Image src={img.image} alt={"carousel-image"} className={styles.image} fill />
                <div className={styles.carouselContent}>
                  <div className={styles.text}>
                    <span className={styles.description}> {img.desc}</span>
                  </div>
                  <Link href={img.link}>
                    <button className={styles.visitLink}>
                      See more
                      <MdArrowOutward size={20} />
                    </button>
                  </Link>
                </div>
                <div className={styles.carouselGradient} />
              </div>
            ))}
          </AntCarousel>
          <div className={styles.carouselControls}>
            <ArrowButtonLeft onClick={() => handleIterate("prev")} />
            <div className={styles.sliderDots}>
              {CAROUSEL_SLIDES.map((img, i) => (
                <div key={i} className={styles.dotContainer} onClick={() => handleGoTo(i)}>
                  <div className={classNames(styles.dot, activeSlide === i && styles.active)} />
                </div>
              ))}
            </div>
            <ArrowButtonRight onClick={() => handleIterate("next")} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
